import { toRem } from "../../../../../helpers/theme";

/* eslint-disable quote-props, no-dupe-keys, max-len */
const style = ({ theme, inline }) => {
    const imageSizeConfig = {
        mobile: {
            outline: 80,
            inline: 70,
        },
        desktop: {
            outline: 156,
            inline: 140,
        },
    };

    const imageOutlineSize = {
        width: toRem(imageSizeConfig.mobile.outline),
        height: toRem(imageSizeConfig.mobile.outline),
        [theme.breakpoints.up("md")]: {
            width: toRem(imageSizeConfig.desktop.outline),
            height: toRem(imageSizeConfig.desktop.outline),
        },
    };

    const imageInnerSize = {
        width: toRem(imageSizeConfig.mobile.inline),
        height: toRem(imageSizeConfig.mobile.inline),
        [theme.breakpoints.up("md")]: {
            width: toRem(imageSizeConfig.desktop.inline),
            height: toRem(imageSizeConfig.desktop.inline),
        },
    };

    return {
        display: inline ? "inline-flex" : "flex",
        flexDirection: "column",
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
        },
        backgroundColor: theme.colors.userProfileHead.avatar.background,
        "& .avatar_asset": {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            ...imageOutlineSize,
            border: `1px solid ${theme.colors.userProfileHead.avatar.border}`,
            borderRadius: "50%",
        },
        "& .avatarAsset_imageWrap": {
            ...imageInnerSize,
            overflow: "hidden",
            borderRadius: "50%",
        },
        "& .avatarAsset_image": {},
        "& .avatar_info": {
            display: "inline-flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            marginTop: toRem(15),
            [theme.breakpoints.up("md")]: {
                marginTop: "unset",
                marginLeft: toRem(10),
            },
        },
        "& .avatarInfo_userName": {},
        "& .avatarInfo_title": {
            marginTop: toRem(3),
            color: theme.colors.userProfileHead.avatar.title,
            fontSize: toRem(14),
            [theme.breakpoints.up("md")]: {
                fontSize: toRem(16),
            },
        },
    };
};

export default style;
